{
    "Detailstitle": "Details oproepsegment",
    "Recordingtitle": "Opname van gesprekssegmenten",
    "Details": "CME-details",
    "Recording": "Opnemen",
    "Value": "Waarde",
    "Collapseall": "Alles inklappen",
    "FieldStatistic": "statistisch alarm",
    "Calldatetimevalues": "Bel Datum \/ Tijd Waarden",
    "Deviceinformation": "Apparaat informatie",
    "Calltypestatus": "Oproeptype en status",
    "Callmovement": "Scenario-informatie voor oproepbeweging",
    "Calldurationvalues": "Waarden gespreksduur",
    "Telephoneinformation": "Telefoonnummer Informatie",
    "Acdinformation": "ACD-agentinformatie",
    "Associatedtelephonyenvironment": "Bijbehorende telefonieomgeving",
    "Diagnosticvalues": "Diagnostische waarden",
    "Previous": "Vorig",
    "Next": "Volgende",
    "Playrecording": "Opname afspelen",
    "Errorplayrecording": "Aanmelden mislukt",
    "Norecording": "Geen opname(s)",
    "Retrievingrecordings": "Opnamen ophalen...",
    "Backtodetails": "CME-details",
    "Segmentid": "Segmentketen-ID kopiëren",
    "Copied": "gekopieerd!",
    "Help": "Helpen?",
    "Close": "Afsluiten",
    "RecordingTimeoutError": "Het maximum aantal pogingen om de gespreksopnames voor dit gesprek op te halen, is overschreden.",
    "EditableHint": "Klik op de beschrijving om dit veld te bewerken.",
    "EditPlaceholder": "Klik hier om een beschrijving toe te voegen",
    "ReloadDataP1": "Er is onlangs een vermelding bijgewerkt,",
    "ReloadDataP2": "Zet je bestanden hier neer...",
    "ReloadDataP3": "om de gegevens opnieuw te laden.",
    "DescMaxLengthValidation": "Er is een maximale tekenlengte van 100.",
    "ConfirmChange": "Bevestigen",
    "CancelChange": "Annuleren",
    "NAME": "CallDetails",
    "AccountCodeHint": "Klik op de accountcode om dit veld te bewerken.",
    "AccountCodePlaceholder": "Klik hier om accountcode toe te voegen",
    "DescriptionHint": "Klik op de beschrijving om dit veld te bewerken.",
    "DescriptionPlaceholder": "Klik hier om een beschrijving toe te voegen",
    "NoAccountCodes": "Geen accountcodes beschikbaar",
    "First": "Eerst",
    "Last": "Laatst",
    "CallJourneyTitle": "Belreis",
    "CallRecordingTitle": "Gespreksopname",
    "CallSegmentTitle": "Segment {} van {}",
    "TabTextTimeline": "Tijdlijn",
    "TabTextSegments": "Segmenten",
    "TabTextRecording": "Opname",
    "StatisticDeviceCalled": "Genoemde naam\/nummer",
    "StatisticDeviceCalling": "Bellende naam\/nummer",
    "StatisticTotalCallTime": "Totale gesprekstijd",
    "StatisticStatus": "Status",
    "Answered": "Beantwoord",
    "NotAnswered": "Niet beantwoord",
    "StatisticTotalCallTimeInProgress": "Gesprek in uitvoering"
}